// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://ratvlhyqfgkuniauyvez.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InJhdHZsaHlxZmdrdW5pYXV5dmV6Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3Mzk0NjE4NDgsImV4cCI6MjA1NTAzNzg0OH0.ek1Odl7G6NazDwzwYpj96kHP3GIEM2hXYiZ4BOU7qLw";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);